import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Company } from "../../types/company";
interface RootState {
  company: Company[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  companyId: string | null;
  loginRole:string | null;
  loginRoles: string[];   
}

const initialState: RootState = {
  company: [],
  status: 'idle',
  error: null,
  companyId: null,
  loginRole:null,
 loginRoles: [], 
};

export const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanyId: (state, action: PayloadAction<string>) => {
      state.companyId = action.payload;
    },
    SetCompany: (state, action: PayloadAction<Company[]>) => {
      state.company=action.payload;
      state.status='succeeded';
      state.error=null;
    }, setLoad: (state) => {
      state.status = 'loading';
      state.error = null;
    },
    UpdateCompany:(state,action:PayloadAction<Company>)=>{
      const index=state.company.findIndex((e)=>e.id===action.payload.id);
      if(index!== -1)
      {
        state.company[index]=action.payload;
      }
      state.status = 'succeeded';
      state.error = null;
    },
    setErrors: (state, action: PayloadAction<string>) => {
      state.status = 'failed';
      state.error = action.payload;
    },
    AddCompanies:(state,action:PayloadAction<Company>)=>{
      state.company.push(action.payload);
      state.status='succeeded';
      state.error=null;
    },
    setLoginRole: (state, action: PayloadAction<string>) => {
      state.loginRole = action.payload;
    },
   
setLoginAllRoles: (state, action: PayloadAction<string[]>) => {
  state.loginRoles = action.payload;
}


  }
});

export const { SetCompany, setLoad, setErrors,UpdateCompany,AddCompanies,setCompanyId, setLoginRole, setLoginAllRoles} = companySlice.actions;
export default companySlice.reducer;
